import { PropsWithChildren, useState } from "react";
import Menu from "../Menu/Menu";
import userImage from "assets/images/userImage.png";
import logo from "assets/images/logo.svg";
import "./AuthenticatedLayout.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { getRoutePath } from "routes/route-utils";
import { AdyenRoutesName } from "routes/route-names";
import useUser from "hooks/useUser";

export const AuthenticatedLayout = ({ children }: PropsWithChildren<{}>) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUser();
  const marketplaceId = localStorage.getItem("marketplaceId");

  const handleLogout = () => {
    localStorage.clear();
    navigate(getRoutePath(AdyenRoutesName.LOGIN), {
      state: { from: location },
    });
  };

  return (
    <div className="page">
      <header className="main-header">
        <h1 className="main-header__logo-container">
          <img className="main-header__logo" src={logo} alt="Adyen Connector" />
          <span className="main-header__logo-container__version">Version {process.env.REACT_APP_VERSION}</span>
        </h1>
        <div className="main-header__user-area">
          <p className="main-header__user-area__greetings">
            Welcome,{" "}
            <strong className="main-header__user-area__user-name">
              {user?.name}
            </strong>
          </p>
          <img
            className="main-header__user-area__user-photo"
            src={userImage}
            alt=""
          />
          <span className="line-break"></span>
          <button type="button" onClick={() => handleLogout()}>
            Logout
          </button>
        </div>
      </header>
      <div className="content-wrapper">
        {!marketplaceId && <Menu opened={isMenuOpened} />}
        <main className="main-container-wrapper">
          {!marketplaceId && (
            <button
              className={`menu-toggle-button ${
                isMenuOpened ? "opened" : "closed"
              }`}
              onClick={() => setIsMenuOpened(!isMenuOpened)}
            >
              <span
                className={`menu-toggle-button__icon icon-angle-${
                  isMenuOpened ? "left" : "right"
                }`}
              ></span>
            </button>
          )}
          {children}
        </main>
      </div>
      {/* <span className="tutorial-link">
        <a href="/tutorial" className="button">
          Connector Tutorial
        </a>
        &nbsp;
        <a href="/boarding-tutorial" className="button">
          Mirakl Boarding Tutorial
        </a>
      </span> */}
    </div>
  );
};
